import {inject, RESPONSE_INIT} from '@angular/core';
import {RedirectCommand, type ResolveFn, Router} from '@angular/router';
import {redirectTo404} from '@app/navigation/page-not-found/page-not-found.component';
import {CommonsSearchDataset} from '@models/commons-types';
import {SearchService} from '@services/search/search.service';

export const publicDatasetResolver: ResolveFn<CommonsSearchDataset | RedirectCommand> = async (route, _state) => {
  const router = inject(Router);
  const searchService = inject(SearchService);
  const response = inject(RESPONSE_INIT);

  const datasetId = route.paramMap.get('datasetId');

  if (!datasetId) {
    return redirectTo404(router, response);
  }

  try {
    const dataset = await searchService.searchByID(
      {id: {terms: datasetId}},
      {public_view: true, page: 1, per_page: 1},
      'Datasets',
    );

    if (!dataset || dataset.scheduled_for_deletion_on) {
      return redirectTo404(router, response);
    }

    return dataset;
  } catch (err) {
    console.log(err);
    return redirectTo404(router, response);
  }
};
